import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/login.vue';
import Register from '@/views/register.vue';

import NoAuth from '@/views/common/noAuth.vue';
import NotFound from '@/views/common/notFound.vue';

import Home from '@/views/bigdata/project/home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/bigdata/login',
      name: 'login',
      component: Login,
      meta: {
        showHeader: false,
        auth: false,
      },
    },
    {
      path: '/bigdata/register',
      name: 'register',
      component: Register,
      meta: {
        showHeader: false,
        auth: false,
      },
    },
    {
      path: '/bigdata/home',
      alias: ['/', '/bigdata'],
      name: 'home',
      component: Home,
    },
    {
      path: '/bigdata/overview/:id',
      name: 'overview',
      props: true,
      component: () => import('@/views/bigdata/project/overview.vue'),
    },
    {
      path: '/bigdata/monitor/:id',
      name: 'monitor',
      props: true,
      component: () => import('@/views/bigdata/project/monitor.vue'),
    },
    {
      path: '/bigdata/tasks/:id',
      name: 'tasks',
      props: true,
      component: () => import('@/views/bigdata/project/tasks.vue'),
    },
    {
      path: '/bigdata/timeline/:id',
      name: 'timeline',
      props: true,
      component: () => import('@/views/bigdata/project/timeline.vue'),
    },
    {
      path: '/bigdata/noAuth',
      name: 'noAuth',
      component: NoAuth,
      meta: {
        showHeader: false,
        auth: false,
      },
    },
    {
      path: '/bigdata/*',
      name: 'notFound',
      component: NotFound,
      meta: {
        showHeader: false,
        auth: false,
      },
    },
  ],
});
